import { useState, useEffect } from 'react';
import type { DiaryEntry } from '../types/diary.types';
import { fetchDiaryEntries } from '../api/diary.api';

type UseDiaryEntriesResult = {
  entries: DiaryEntry[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
};

export const useDiaryEntries = (): UseDiaryEntriesResult => {
  const [entries, setEntries] = useState<DiaryEntry[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchEntries = async (): Promise<void> => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await fetchDiaryEntries('asc');
      setEntries(data);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Wystąpił błąd podczas ładowania wpisów');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    void fetchEntries();
  }, []);

  return {
    entries,
    isLoading,
    error,
    refetch: fetchEntries,
  };
};
